"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanUpAsset = exports.formatPriceHistory = exports.getEthPrice = exports.formatPenalty = exports.formatItemHtmlList = exports.formatItemMuiList = exports.formatItem = exports.formatItemCore = exports.formatEther = exports.formatUnitsR = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ethers_1 = require("ethers");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const formatUnitsR = (value, decimals = 0, maxDecimalDigits) => {
    return ethers_1.FixedNumber.fromValue(value, 18)
        .round(maxDecimalDigits ?? Number(BigInt(decimals)))
        .toString();
};
exports.formatUnitsR = formatUnitsR;
const formatEther = (amount = "0", decimals = 18, currency = "Ξ", maxDecimalDigits) => {
    return `${currency} ${(0, exports.formatUnitsR)(amount, decimals, maxDecimalDigits)}`;
};
exports.formatEther = formatEther;
const formatItemCore = (asset, maxDecimalDigits) => {
    if (!asset?.components) {
        return [];
    }
    return asset.components
        .map(component => {
        switch (component.contract?.contractType) {
            case types_1.TokenType.NATIVE:
            case types_1.TokenType.ERC20:
                return (0, exports.formatEther)(component.amount, component.contract.decimals, component.contract.symbol, maxDecimalDigits);
            case types_1.TokenType.ERC721:
            case types_1.TokenType.ERC998:
            case types_1.TokenType.ERC1155:
                return !component.templateId || !component.template
                    ? `${component.amount === "1" ? "" : `${component.amount} x`} ${component.contract.title}`
                    : BigInt(component.amount) > 1n
                        ? `${component.amount} x ${component.template?.title}`
                        : component.tokenId
                            ? `${component.template?.title} #${component.template.tokens[0].tokenId}`
                            : component.template?.title || "";
            default:
                return "unsupported token type";
        }
    })
        .filter(Boolean);
};
exports.formatItemCore = formatItemCore;
const formatItem = (asset, maxDecimalDigits) => {
    return (0, exports.formatItemCore)(asset, maxDecimalDigits).join(", ");
};
exports.formatItem = formatItem;
const formatItemMuiList = (asset, maxDecimalDigits) => {
    return (0, exports.formatItemCore)(asset, maxDecimalDigits).map((item, index) => ((0, jsx_runtime_1.jsx)(ui_kit_1.List.Item, { children: (0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { primary: item }) }, index)));
};
exports.formatItemMuiList = formatItemMuiList;
const formatItemHtmlList = (asset, maxDecimalDigits) => {
    return (0, exports.formatItemCore)(asset, maxDecimalDigits).map((item, index) => ((0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { sx: { padding: 0 }, children: item }, index)));
};
exports.formatItemHtmlList = formatItemHtmlList;
const formatPenalty = (penalty) => {
    return penalty ? +(penalty / 100).toFixed(2) : 0;
};
exports.formatPenalty = formatPenalty;
const getEthPrice = (asset) => {
    const total = asset?.components.reduce((memo, current) => {
        if (current.tokenType === types_1.TokenType.NATIVE) {
            return memo + BigInt(current.amount);
        }
        return memo;
    }, BigInt(0));
    return total || BigInt(0);
};
exports.getEthPrice = getEthPrice;
const formatPriceHistory = (components) => {
    return (components
        ?.map(component => {
        return (0, exports.formatEther)(component.amount, component.contract.decimals, component.contract.symbol);
    })
        .join(", ") || "");
};
exports.formatPriceHistory = formatPriceHistory;
const cleanUpAsset = ({ components } = { components: [], id: 0 }) => {
    return {
        components: components.map(({ id, tokenId, tokenType, contractId, templateId, amount }) => ({
            id,
            tokenId,
            tokenType,
            contractId,
            templateId,
            amount,
        })),
    };
};
exports.cleanUpAsset = cleanUpAsset;
//# sourceMappingURL=money.js.map